import { Injectable } from '@angular/core';
import { SelectableCategory } from './models/categories/category.models';
import { LocationsByRegionDto } from './models/locations/location.models';
import { SelectableLocation } from './models/locations/location.models';
import { SelectableRegion } from './models/locations/location.models';

@Injectable()
export class Helpers {
    uriEncode = (obj: any) => Object.keys(obj).map((key) => {
        var value = obj[key];

        let encodedValue = '';

        if (value instanceof Array) {
            encodedValue = value.map(entry => encodeURIComponent(key) + '=' + encodeURIComponent(entry)).join('&');

            return encodedValue;
        } else if (value) {
            encodedValue = encodeURIComponent(value);
        }

        return encodeURIComponent(key) + '=' + encodedValue;
    }).join('&');

    clone<T>(obj: T) {
        return jQuery.extend(true, {}, obj);
    }
}

export interface IMap<T> {
    [key: string]: T
}

@Injectable()
export class CategoryAndLocationHelpers {
    setSelectedCategories(categories: Array<SelectableCategory>, selectedIds: Array<number>) {
        var updateSelection = (category: SelectableCategory, ids: Array<number>) => {
            category.isSelected = ids.indexOf(category.id) > -1;

            category.children.forEach((child: SelectableCategory) => {
                updateSelection(child, ids);
            });

            if (!category.isSelected) {
                category.isSelected = category.children.length > 0 &&
                    category.children.every((c: SelectableCategory) => { return c.isSelected });
            }

            category.isExpanded = category.children.some((c: SelectableCategory) => {
                return c.isSelected;
            });
        }

        categories.forEach((category: SelectableCategory) => {
            updateSelection(category, selectedIds);
        });
    }

    setSelectedLocations(locationsByRegion: LocationsByRegionDto, selectedIds: Array<number>) {
        var updateSelection = (location: SelectableLocation, ids: Array<number>) => {
            location.isSelected = ids.indexOf(location.id) > -1;
        }

        locationsByRegion.regions.forEach((region: SelectableRegion) => {
            region.locations.forEach((location: SelectableLocation) => {
                updateSelection(location, selectedIds);
            });

            region.isSelected = region.locations.every((l: SelectableLocation) => { return l.isSelected });
        });

        locationsByRegion.locationsWithoutRegion.forEach((location: SelectableLocation) => {
            updateSelection(location, selectedIds);
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/helpers.ts